import { Card, Form, Image, Select } from 'antd';
import React, { useEffect,useState } from 'react';
import { ToothSample } from '../../models';
interface PropsType {
  editRecord: ToothSample;
}
export const CATItem: React.FC<PropsType> = ({ editRecord }) => {
  const [form] = Form.useForm();
  const [catStr, setCatStr] = useState("");
  const setForm = () => {
    let cat:any;
    if (editRecord.cat !== -1) {
      cat = editRecord.cat;
      if (cat < 1) {
        setCatStr("低");
      } else if (cat <2) {
        setCatStr("中");
      } else {
        setCatStr("高");
      }
    } else {
      cat = undefined;
      setCatStr("");
    }

    form.setFieldsValue({ cat: cat});
  }
  
  useEffect(() => {
    setForm();
  }, [editRecord,form]);
  const onCATChange = (e: any) => {
    editRecord.cat = e;
    setForm();
  }
  return (
    <Card title="龋活跃性检测数值" headStyle={{ background: "green", color: "white" }} style={{ background: "#ececec", margin: "10px" }}>
      <Form layout="horizontal"
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        form={form}>
          <Form.Item name="catgraph" label='CAT值图示'>
            <Image src="cat.jpg"/>
          </Form.Item>
          <Form.Item
          name="cat"
          label='CAT值:'
        >

          <Select onChange={onCATChange} placeholder="请选择CAT值范围">
            <Select.Option key={1} value={0}>{"0"}</Select.Option>
            <Select.Option key={2} value={0.5}>{"0.5"}</Select.Option>
            <Select.Option key={3} value={1.0}>{"1.0"}</Select.Option>
            <Select.Option key={4} value={1.5}>{"1.5"}</Select.Option>
            <Select.Option key={5} value={2.0}>{"2.0"}</Select.Option>
            <Select.Option key={6} value={2.5}>{"2.5"}</Select.Option>
            <Select.Option key={7} value={3.0}>{"3.0"}</Select.Option>
          </Select>

        </Form.Item>
        <Form.Item
          name="catrange"
          label='CAT值对应的风险级别:'
        >
          <span>{catStr}</span>

        </Form.Item>
        
        
      </Form>
    </Card>
  );
}